var metaInfo={
    title:"汽车行业_Movibot服务行业",
    keywords:"工业机器人_汽车行业_汽车零部件加工_汽车组装生产线",
    description:"工业机器人为汽车行业提供物料搬运、零部件加工组装、焊接、上下料相关服务，助力汽车行业发展，提升汽车零部件加工、汽车组装生产线的生产效率。",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/7.js